/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React from "react";
import sass from "./accept.module.sass";
import { Button } from "components/shared";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";

interface IAccept {
	submit: () => void;
	abort: () => void;
}

const Accept: React.FC<IAccept> = ({ submit, abort }) => {
	return (
		<div className={sass.wrapper}>
			<div className={sass.btn}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={() => abort()}>
					Отмена
				</Button>
				<Button color={BUTTON_COLORS.ERROR} onClick={() => submit()}>
					Удалить
				</Button>
			</div>
		</div>
	);
};

export default Accept;
